<template>
  <div class="p-8 bg-[#F4F7F9] min-h-screen font-sans text-[#222]">
    
    <nav class="mb-8 justify-between items-center w-full flex">
      <button @click="goBack" class="flex items-center gap-2 text-gray-400 hover:text-black transition font-black uppercase text-[10px] tracking-widest">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="3" d="M10 19l-7-7m0 0l7-7m-7 7h18" /></svg>
        Retour au Hub d'incidents
      </button>
      <span class="px-3 py-1 bg-green-100 text-green-600 rounded-lg text-[10px] font-black uppercase tracking-widest">En Ligne</span>
    </nav>

    <div class="grid lg:grid-cols-12 gap-8">
      
      <div class="lg:col-span-8 space-y-8">
        
        <div class="bg-white rounded-[2.5rem] p-8 shadow-sm border border-gray-100 flex flex-col md:flex-row justify-between items-center gap-6">
          <div class="flex items-center gap-6">
            <div class="w-20 h-20 bg-gray-900 rounded-[2rem] flex items-center justify-center shadow-2xl">
              <svg class="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
            </div>
            <div>
              <div class="flex items-center gap-3 mb-1">
                <h1 class="text-3xl font-black tracking-tighter uppercase">{{ machine.name }}</h1>
              </div>
              <p class="text-gray-400 font-bold text-xs uppercase tracking-widest">{{ machine.agence }} • IP: {{ machine.ip }}</p>
            </div>
          </div>
          <div class="flex gap-3">
            <button @click="forceReboot" class="px-6 py-4 bg-red-50 text-red-600 rounded-2xl text-[10px] font-black uppercase hover:bg-red-600 hover:text-white transition shadow-sm">Force Reboot</button>
            <button @click="syncConfig" class="px-6 py-4 bg-gray-900 text-white rounded-2xl text-[10px] font-black uppercase hover:bg-black transition shadow-lg shadow-gray-200">Sync Config</button>
          </div>
        </div>

        <div class="bg-[#1A1A1A] rounded-[2.5rem] shadow-2xl overflow-hidden border border-white/5">
          <div class="p-6 border-b border-white/10 flex justify-between items-center bg-white/[0.02]">
            <div class="flex items-center gap-3">
              <div class="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
              <h3 class="text-xs font-black uppercase tracking-widest text-white">Console de Debug (Journal Système)</h3>
            </div>
            <button class="text-[9px] font-black uppercase text-gray-500 hover:text-white transition">Clear Console</button>
          </div>
          <div class="p-8 font-mono text-[11px] h-[400px] overflow-y-auto custom-scrollbar">
            <div v-for="(log, i) in logs" :key="i" class="mb-2 flex gap-4">
              <span class="text-gray-600 shrink-0">[{{ log.time }}]</span>
              <span :class="log.type === 'error' ? 'text-red-400' : 'text-blue-400'" class="font-bold shrink-0">{{ log.tag }}</span>
              <span class="text-gray-300">{{ log.message }}</span>
            </div>
            <div class="mt-4 flex gap-2 items-center">
              <span class="text-green-500 font-bold">></span>
              <input type="text" placeholder="Entrer une commande SSH..." class="bg-transparent border-none text-white focus:ring-0 w-full p-0 text-[11px]">
            </div>
          </div>
        </div>

                <div class="bg-white rounded-[2.5rem] p-8 shadow-sm border border-gray-100">
          <h3 class="text-sm font-black uppercase tracking-widest mb-6 border-b border-gray-50 pb-4">Historique (30j)</h3>
          <div class="space-y-6 relative">
            <div class="absolute left-3 top-2 bottom-2 w-0.5 bg-gray-100"></div>

            <div v-for="(hist, idx) in history" :key="idx" class="relative pl-10">
              <div class="absolute left-0 top-1 w-6 h-6 bg-white border-4 border-gray-100 rounded-full flex items-center justify-center z-10">
                <div class="w-1.5 h-1.5 bg-gray-400 rounded-full"></div>
              </div>
              
              <div class="mb-1 flex justify-between items-start">
                <span class="text-[9px] font-black uppercase text-gray-400 tracking-tighter">{{ hist.date }}</span>
                <span class="text-[8px] font-black px-2 py-0.5 bg-gray-100 rounded-md uppercase">{{ hist.tech }}</span>
              </div>
              <p class="text-[11px] font-bold text-gray-800 leading-tight">{{ hist.action }}</p>
              <p class="text-[10px] text-gray-400 mt-1 italic leading-relaxed">"{{ hist.comment }}"</p>
            </div>
          </div>
        </div>
      </div>

      <div class="lg:col-span-4 space-y-8">
        
        <div class="bg-white rounded-[2.5rem] p-8 shadow-sm border border-gray-100">
          <h3 class="text-sm font-black uppercase tracking-widest mb-6 border-b border-gray-50 pb-4">Rapport d'Intervention</h3>
          
          <div class="space-y-6">
            <div>
              <label class="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-2">Cause de la panne</label>
              <select v-model="issueCategory" class="w-full bg-gray-50 border-none rounded-2xl py-4 px-4 text-xs font-bold focus:ring-2 focus:ring-gray-100 transition-all">
                <option>Hardware - Imprimante</option>
                <option>Hardware - Écran</option>
                <option>Logiciel - Crash</option>
                <option>Logiciel - Lenteur</option>
                <option>Réseau - Connexion</option>
                <option>Réseau - Webhook</option>
                <option>Maintenance - Préventive</option>
                <option>Autre</option>
              </select>
            </div>

            <div>
              <label class="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-2">Action effectuée</label>
              <textarea v-model="report" class="w-full bg-gray-50 border-none rounded-2xl py-4 px-4 text-xs font-medium focus:ring-2 focus:ring-gray-100 transition-all" rows="4" placeholder="Détaillez votre intervention ici..."></textarea>
            </div>

            <div class="p-4 bg-blue-50 rounded-2xl border border-blue-100">
              <div class="flex items-center gap-3">
                <input v-model="resolved" type="checkbox" class="rounded border-blue-300 text-blue-600 focus:ring-blue-500">
                <span class="text-[10px] font-bold text-blue-700">Marquer comme résolu</span>
              </div>
            </div>

            <button @click="saveAndExit" class="w-full py-5 bg-blue-600 text-white rounded-[1.5rem] text-[11px] font-black uppercase tracking-[0.2em] shadow-xl shadow-blue-100 hover:bg-blue-700 transition-all">
              Valider l'Intervention
            </button>
          </div>
        </div>



        <div class="bg-white rounded-[2.5rem] p-8 shadow-sm border border-gray-100">
          <h3 class="text-[10px] font-black uppercase text-gray-400 mb-6 tracking-widest">Spécifications</h3>
          <div class="space-y-4">
            <div class="flex justify-between border-b border-gray-50 pb-2">
              <span class="text-[10px] font-bold text-gray-400 italic">Version Logicielle</span>
              <span class="text-xs font-black">v4.2.1-stable</span>
            </div>
            <div class="flex justify-between border-b border-gray-50 pb-2">
              <span class="text-[10px] font-bold text-gray-400 italic">Mémoire Vive</span>
              <span class="text-xs font-black">2.4 GB / 4.0 GB</span>
            </div>
            <div class="flex justify-between">
              <span class="text-[10px] font-bold text-gray-400 italic">Disque (SSD)</span>
              <span class="text-xs font-black">12% utilisé</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { toast } from 'vue3-toastify';
import { useRoute } from 'vue-router';
import io from 'socket.io-client';

export default {
  data() {
    return {
      report: '',
      issueCategory: 'Problème Hardware (Imprimante)',
      resolved: false,
      deviceId: null,
      machine: {
        id: '',
        name: '',
        agence: '',
        ip: '',
        status: 'offline',
        systemInfo: {}
      },
      logs: [],
      history: [],
      socket: null
    }
  },
  mounted() {
    const route = useRoute();
    this.deviceId = route.params.id;
    this.fetchDeviceInfo();
    this.setupWebSocket();

    // Auto-refresh logs toutes les 5 secondes
    setInterval(() => {
      if (this.machine.online) {
        this.fetchDeviceInfo();
      }
    }, 5000);
  },
  beforeUnmount() {
    if (this.socket) {
      this.socket.disconnect();
    }
  },
  methods: {
    getHeaders() {
      return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('superAdminToken')}`
      };
    },

    async fetchDeviceInfo() {
      try {
        const res = await fetch(`https://api.datafuse.fr/api/super-admin/devices/${this.deviceId}`, {
          headers: this.getHeaders()
        });

        if (res.ok) {
          const device = await res.json();
          this.machine = {
            id: device.identifier,
            name: device.name,
            agence: device.agencyId?.name || 'N/A',
            ip: device.ip,
            status: device.online ? 'online' : 'offline',
            systemInfo: device.systemInfo || {}
          };

          // Logs (derniers 20)
          this.logs = (device.logs || []).slice(-20).map(l => ({
            time: new Date(l.timestamp).toLocaleTimeString('fr-FR'),
            tag: l.tag,
            type: l.level === 'ERROR' || l.level === 'CRITICAL' ? 'error' : 'info',
            message: l.message
          }));

          // Historique
          this.history = (device.interventionHistory || []).map(h => ({
            date: new Date(h.date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' }),
            tech: h.technician,
            action: h.action,
            comment: h.comment
          }));
        }
      } catch (err) {
        console.error('Erreur fetch device:', err);
        toast.error('Erreur chargement device');
      }
    },

    setupWebSocket() {
      this.socket = io('https://api.datafuse.fr');

      // Écouter les logs en temps réel
      this.socket.on('device_logs', (data) => {
        if (data.deviceId === this.deviceId) {
          data.logs.forEach(log => {
            this.logs.push({
              time: new Date(log.timestamp).toLocaleTimeString('fr-FR'),
              tag: log.tag,
              type: log.level === 'ERROR' || log.level === 'CRITICAL' ? 'error' : 'info',
              message: log.message
            });
          });

          // Garder seulement les 50 derniers
          if (this.logs.length > 50) {
            this.logs = this.logs.slice(-50);
          }
        }
      });

      // Écouter les résultats de commandes
      this.socket.on('command_executed', (data) => {
        if (data.deviceId === this.deviceId) {
          if (data.status === 'completed') {
            toast.success(`Commande exécutée: ${data.result || 'OK'}`);
          } else if (data.status === 'failed') {
            toast.error(`Commande échouée: ${data.result}`);
          }
        }
      });
    },

    async sendCommand(type, params = {}) {
      try {
        const res = await fetch(`https://api.datafuse.fr/api/super-admin/devices/${this.deviceId}/commands`, {
          method: 'POST',
          headers: this.getHeaders(),
          body: JSON.stringify({ type, params })
        });

        if (res.ok) {
          toast.loading('Commande envoyée au device...');
        } else {
          toast.error('Erreur envoi commande');
        }
      } catch (err) {
        console.error('Erreur envoi commande:', err);
        toast.error('Erreur envoi commande');
      }
    },

    async forceReboot() {
      if (confirm("Action critique : Redémarrer physiquement la borne ?")) {
        await this.sendCommand('reboot');
      }
    },

    async syncConfig() {
      await this.sendCommand('sync_config');
      toast.success('Commande de synchronisation envoyée');
    },

    async saveAndExit() {
      if (!this.report.trim()) {
        toast.error('Veuillez décrire l\'intervention');
        return;
      }

      try {
        const userId = localStorage.getItem('userId');
        const userName = localStorage.getItem('userName') || 'Admin';

        const reportData = {
          kioskId: this.deviceId,
          agencyId: this.machine.agencyId,
          technician: {
            userId: userId,
            name: userName
          },
          issue: {
            category: this.issueCategory,
            description: this.report,
            severity: 'Modérée'
          },
          action: {
            performed: this.report,
            steps: [this.report],
            duration: 0
          },
          status: this.resolved ? 'resolved' : 'in-progress',
          resolution: {
            resolved: this.resolved,
            resolvedAt: this.resolved ? new Date() : null,
            notes: this.report
          }
        };

        const res = await fetch('https://api.datafuse.fr/api/super-admin/intervention-reports', {
          method: 'POST',
          headers: this.getHeaders(),
          body: JSON.stringify(reportData)
        });

        if (res.ok) {
          toast.success('Intervention enregistrée');
          setTimeout(() => {
            this.goBack();
          }, 1500);
        } else {
          toast.error('Erreur enregistrement');
        }
      } catch (err) {
        console.error('Erreur save rapport:', err);
        toast.error('Erreur enregistrement');
      }
    },

    goBack() {
      this.$router.push('/maintenance');
    }
  }
}
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar { width: 4px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 10px; }
</style>